// test1212
(1212 && 0);
